// Page context, mirroring functions/lib/pageContext.js (pinned by
// parity.test.ts): whether a bot reads the page the visitor is on (no code),
// whether it takes data the page's own code passes, and the owner's words for
// what that data means.
export type PageContextSettings = { enabled: boolean; readPage: boolean; description: string };

// The guide for owners and their developers (pages/PageContextGuide.tsx).
export const PAGE_CONTEXT_GUIDE = "/help/page-context";

export const MAX_PAGE_CONTEXT_DESCRIPTION = 4000;

export function normalizePageContext(input: Partial<PageContextSettings> | null | undefined): PageContextSettings {
  return {
    enabled: input?.enabled === true,
    readPage: input?.readPage === true,
    description: String(input?.description || "").replace(/\r\n/g, "\n").trim().slice(0, MAX_PAGE_CONTEXT_DESCRIPTION)
  };
}

export function pageContextSummary(value: PageContextSettings): string {
  const on = [value.readPage ? "reads the page" : null, value.enabled ? (value.description.trim() ? "data from your code, described" : "data from your code") : null].filter(Boolean);
  return on.length ? `On: ${on.join(", ")}` : "Off";
}

// The line a developer adds to the page, shown on the card.
export const SET_CONTEXT_EXAMPLE = `BuildBotsNow.setContext({
  plan: "Pro",
  lastOrder: { id: "A-1042", status: "shipped" }
});`;

// What a site with sign-in adds where it learns who is signed in.
export const SET_VISITOR_EXAMPLE = `BuildBotsNow.setVisitor(user ? user.id : null);`;
